
import OrganizationDetailsSection from "./OrganizationDetailsSection";
import OrganizationAdminSection from "./OrganizationAdminSection";
import SubscriptionDetailsSection from "./SubscriptionDetailsSection";
import AppsApiSettingsSection from "./AppsApiSettingsSection";
import GeneralSettingsSection from "./GeneralSettingsSection";

interface OrganizationInfoSectionProps {
  isEdit?: boolean;
}

const OrganizationInfoSection = ({ isEdit }: OrganizationInfoSectionProps) => {
  return (
    <>
      <OrganizationDetailsSection isEdit={isEdit} />
      <hr />
      <OrganizationAdminSection isEdit={isEdit} />
      <hr />
      <SubscriptionDetailsSection isEdit={isEdit} />
      <hr />
      <AppsApiSettingsSection isEdit={isEdit} />
      <hr />
      <GeneralSettingsSection isEdit={isEdit} />
    </>
  );
};

export default OrganizationInfoSection;
